// styled components
import {
  Row,
  Col,
  Button,
} from "antd";
// style
import "./styleCss.scss";
// navigation
import { useNavigate } from "react-router";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerPanel } from "../../Usuario/components/BannerPanel";
import { MenuUsuario } from "../../Usuario/components/MenuUsuario";

export const InscribirJurado = () => {
  const navigate = useNavigate();
  return (
    <div>
      <Header />
      <BannerPanel />
      <Row
        className="width-100"
        style={{ paddingLeft: "5%", paddingRight: "3%", paddingTop: "16px", paddingBottom: "5%" }}
      >
        <MenuUsuario activeItem={1} />
        <Col span={19}>
          <Row className="width-100 justify-content-center">
            <Row className="width-100 justify-content-center">
              <Row style={{ width: "95%", marginTop: "16px" }} className="justify-content-center">
                <Button className="button-azul-radius" onClick={() => navigate("/usuario/Registrarjurado")}>
                  Inscribir hoja de vida
                </Button>
              </Row>
            </Row>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
